<template>
    <div class="account-data-details">
        <div class="details-top">
            <div></div>
            <el-button class="blue-btn" @click="toBack">返回</el-button>
        </div>

        <div class="details-bottom">
            <AccountDetail :initId="Number($route.query.id)" :isChangeAccount="false"></AccountDetail>
        </div>
    </div>
</template>

<script>
import AccountDetail from "@/components/account/AccountDetail.vue";

export default {
    name: "AccountDataDetails",
    data() {
        return {};
    },

    components: {
        AccountDetail,
    },

    methods: {
        toBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.account-data-details {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 20px;

    .details-top {
        display: flex;
        position: relative;
        justify-content: space-between;

        .blue-btn {
            padding: 8px 25px;
            font-size: 14px;
        }
    }

    .details-bottom {
        position: relative;
    }
}
</style>
